import { create } from "zustand";
import { baseURL, baseURLWithoutAPI } from "../../../baseUrl";
import axios, { all } from 'axios';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { notification } from "antd";


export const useOrders = create((set, get) => ({
    orderImgs: [],
    isRealEstateAgent: false,
    loader: false,
    masterCode: "",
    allDayes: [],
    allAds: [],
    allAdsIDs: [],
    details: [],
    deleteAdsMasterRespons: false,
    showServerError: false,
    comments: [],
    userCode: 0,
    picMaster: [],
    advertiseValidity: [],
    isSuccessAction: false,
    haseMore: false,
    loaderForGetMoreAds: false,
    adsRejectReason: [],
    itemsPerPage: 0,
    totalItems: 0,
    currentPage: 0,
    adsTitleByPhoneNumber: "",
    adsMasterIDByPhoneNumber: 0,
    adsPrptyTypeCodeByPhoneNumber: 0,
    adsPrptyTradeTypeCode: 0,
    responseFromAdsMasterByPhoneNumber: [],
    noAdFound: false,
    actions: {
        clearDetails: async () => {
            set((state) => ({ details: [] }))
        },
        setAllADsIds: async (IDS) => {
            set((state) => ({ allAdsIDs: IDS }))
        },
        clearAllAds: async () => {
            set((state) => ({ allAds: [] }))
        },
        setResponseData: (IDs) => set({ allAdsIDs: IDs }),
        doesRealEstateAgentExists: async (phoneNumber) => {
            console.log("doesRealEstateAgentExists call: " + phoneNumber);
            
            await axios.post(`${baseURL}/RealEstateAgent/DoesRealEstateAgentExists`, {
                "mobile": phoneNumber
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
            .then((res) => {
                
                console.log("doesRealEstateAgentExists result: ");
                console.log(res);
                if(res.data){
                    set((state) => ({isRealEstateAgent: true}))
                }
            })
        },
        getAllAdvertiseValidities: async () => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/AdvertiseValidity/GetAllAdvertiseValidities`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.data) {
                        set((state) => ({ advertiseValidity: res.data }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        editAdvertiseValidity: async (id, adsPrptyTypeCode, adsPrptyTradeTypeCode, adsAdvertiseTypeCode, adsMainCategoryCode, days) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/AdvertiseValidity/EditAdvertiseValidity`, {
                "id": id,
                "adsPrptyTypeCode": adsPrptyTypeCode,
                "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                "adsMainCategoryCode": adsMainCategoryCode,
                "days": days
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'اعتبار آگهی با موفقیت ثبت شد',
                        })
                    }
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsPicMasterByMasterPriorityId: async (masterId, priority) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/Advertise/GetAdsPicMasterByMasterPriorityId?masterId=${masterId}&priority=${priority}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    if (res.data) {
                        set((state) => ({ picMaster: res.data }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        postEditAdsDetail: async (id, adsMasterCode, adsPrptyCategoryCode, adsPrptyTradeTypeCode, adsPrptyTypeCode,
            adsAdvertiseTypeCode, pricePerMeter, totalPrice, propertyLandMetarage, propertyWidth, deposit,
            squareFootageEntireProperty, rentPerMonth, abilityToConvert, convertingDepositAmount,
            convertingRentAmount, meterage, numberOfRooms, lifeOfTheBuilding, dateForRent, floorNumber,
            totalFloor, unitPerFloor, parking, basement, elevator, description) => {
            await axios.patch(`${baseURL}/Advertise/EditAdsDetail`, {
                "id": id,
                "adsMasterCode": adsMasterCode,
                "adsPrptyCategoryCode": adsPrptyCategoryCode,
                "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "adsPrptyTypeCode": adsPrptyTypeCode,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                "pricePerMeter": pricePerMeter,
                "totalPrice": totalPrice,
                "propertyLandMetarage": propertyLandMetarage,
                "propertyWidth": propertyWidth,
                "deposit": deposit,
                "squareFootageEntireProperty": squareFootageEntireProperty,
                "rentPerMonth": rentPerMonth,
                "abilityToConvert": abilityToConvert,
                "convertingDepositAmount": convertingDepositAmount,
                "convertingRentAmount": convertingRentAmount,
                "meterage": meterage,
                "numberOfRooms": numberOfRooms,
                "lifeOfTheBuilding": lifeOfTheBuilding,
                "dateForRent": dateForRent,
                "floorNumber": floorNumber,
                "totalFloor": totalFloor,
                "unitPerFloor": unitPerFloor,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "description": description,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then(res => {

                    localStorage.setItem('idDetail', res.data.id);
                    if (res.status == 200) {
                        set((state) => ({ isSuccessEdit: true }))
                        setTimeout(() => { set((state) => ({ isSuccessEdit: false })) }, 3000)
                    } else {
                        set((state) => ({ isSuccessEdit: false }))
                    }
                })

                .catch(error => {
                    console.error("Error fetching Advertise:", error);
                    set((state) => ({ isSuccessEdit: false }))
                });
        },

        getAdsCommnetByMasterId: async (adsMasterCode) => {
            // set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/Advertise/GetAdsCommnetByMasterId`, {
                "masterID": adsMasterCode
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ comments: res.data }))
                    // set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        clearAdsDetail: async (masterId) => {
            set((state) => ({ details: [] }))
        },
        getDetailsOrders: async (masterId) => {
            set((state) => ({ details: [] }))
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/Advertise/GetAdsMasterDetailByMasterId?masterId=${masterId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data) {


                        set((state) => ({ details: res.data }))
                        // set((state) => ({ usruserCode: res.data[0].usruserCode }))
                        set((state) => ({ userCode: res.data[0].usruserCode }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsCalendar: async (userId, directoryName) => {
            await axios.get(`${baseURL}/Advertise/GetAdsCalendar`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    set((state) => ({ allDayes: res.data }))
                })
        },

        addOrder: async (
            id,
            usruserCode,
            adsMainCategoryCode,
            adsAdvertiseShowTypeCode,
            countryCode,
            stateCode,
            cityCode,
            areaCode,
            latitude,
            longitude,
            isApproximateArea,
            adsTitle,
            mobilePhone,
            landPhone,
            price,
            description,
            isBlockCommnet,
            isActiveChat,
            isShowMobile,
            ownerName,
            address,
            isRenovated,
            balcony,
            officialDeed,
            buildingOrientation,
            floorMaterial,
            bathroomType,
            coolingSystem,
            heatingSystem,
            waterHeaterType,
            deed,
            parcelNumber,
            unitNumber
        ) => {
            console.log('parcelNumber', parcelNumber);
            console.log('address', address);
            console.log('deed', deed);
        
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/Advertise/EditAdsMaster`,
                // {
                //     "id": id,
                //     "usruserCode": usruserCode,
                //     "adsMainCategoryCode": adsMainCategoryCode,
                //     "adsAdvertiseShowTypeCode": adsAdvertiseShowTypeCode,
                //     "countryCode": countryCode,
                //     "stateCode": stateCode,
                //     "cityCode": cityCode,
                //     "areaCode": areaCode,
                //     "latitude": latitude,
                //     "longitude": longitude,
                //     "isApproximateArea": true,
                //     "adsTitle": adsTitle,
                //     "mobilePhone": mobilePhone,
                //     "landPhone": landPhone,
                //     "price": price,
                //     "description": description,
                //     "isBlockCommnet": isBlockCommnet,
                //     "isActiveChat": isActiveChat,
                //     "isShowMobile": isShowMobile,
                //     "ownerName": ownerName,
                //     "address": address
                // }
                {
                    "id": id,
                    "usruserCode": usruserCode,
                    "adsMainCategoryCode": adsMainCategoryCode,
                    "adsAdvertiseShowTypeCode": adsAdvertiseShowTypeCode,
                    "countryCode": countryCode,
                    "stateCode": stateCode,
                    "cityCode": cityCode,
                    "areaCode": areaCode,
                    "latitude": latitude,
                    "longitude": longitude,
                    "isApproximateArea": isApproximateArea,
                    "adsTitle": adsTitle,
                    "address": address,
                    "ownerName": ownerName,
                    "mobilePhone": mobilePhone,
                    "landPhone": null,
                    "price": null,
                    "description": description,
                    "isBlockCommnet": true,
                    "isActiveChat": true,
                    "isShowMobile": true,
                    "isRenovated": isRenovated ?? null,
                    "balcony": balcony ?? null,
                    "officialDeed": officialDeed ?? null,
                    "buildingOrientation": buildingOrientation ?? null,
                    "floorMaterial": floorMaterial ?? null,
                    "bathroomType": bathroomType ?? null,
                    "coolingSystem": coolingSystem ?? null,
                    "heatingSystem": heatingSystem ?? null,
                    "waterHeaterType": waterHeaterType ?? null,
                    "deed": deed ?? null,
                    "parcelNumber": parcelNumber ?? null,
                    "unitNumber": unitNumber ?? null
                }
                , {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    }
                }
            )
                .then(async (res) => {
                    set((state) => ({ loader: false }))
                    localStorage.setItem("adsMasterId", res.data.id)
                    set((state) => ({ masterCode: res.data.id }))

                }).catch(err => {

                })
        },

        addPhoneNumbers: async (
            adsMasterId,
            phoneNumbers
        ) => {
            await axios.post(`${baseURL}/Advertise/AddPhoneNumber`,
                {
                    "adsMasterId": adsMasterId,
                    "phoneNumbers": phoneNumbers
                }
                , {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    }
                }
            )
                .then(async (res) => {

                }).catch(err => {
                    console.log(err);
                })
        },


        saveOrderImg: async (adsMasterId, adsImage, priority) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseURL}/Advertise/EditAdsImage`, {
                "id": 0,
                "adsMasterId": adsMasterId,
                "priority": priority,
                "adsImage": adsImage
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    // "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    // "x-rapidapi-key": "your-rapidapi-key-here",
                },
            }
            )
                .then((res) => {
                    set((state) => ({ loader: false }))
                })
        },


        addOrderDetails: async (
            id,
            adsMasterCode,
            adsPrptyCategoryCode,
            adsPrptyTradeTypeCode,
            adsPrptyTypeCode,
            adsAdvertiseTypeCode,
            pricePerMeter,
            totalPrice,
            propertyLandMetarage,
            propertyWidth,
            deposit,
            rentPerMonth,
            abilityToConvert,
            convertingDepositAmount,
            convertingRentAmount,
            meterage,
            numberOfRooms,
            lifeOfTheBuilding,
            dateForRent,
            floorNumber,
            totalFloor,
            unitPerFloor,
            parking,
            basement,
            elevator,
            description,
            standardCapacity,
            maxAddPeople,
            pricePerAddPeople,

        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseURL}/Advertise/EditAdsDetail`,
                {
                    "id": id,
                    "adsMasterCode": adsMasterCode,
                    "adsPrptyCategoryCode": adsPrptyCategoryCode,
                    "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                    "adsPrptyTypeCode": adsPrptyTypeCode,
                    "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                    "pricePerMeter": pricePerMeter,
                    "totalPrice": totalPrice,
                    "propertyLandMetarage": propertyLandMetarage,
                    "propertyWidth": propertyWidth,
                    "deposit": deposit,
                    "squareFootageEntireProperty": 0,
                    "rentPerMonth": rentPerMonth,
                    "abilityToConvert": abilityToConvert,
                    "convertingDepositAmount": convertingDepositAmount,
                    "convertingRentAmount": convertingRentAmount,
                    "meterage": meterage,
                    "numberOfRooms": numberOfRooms,
                    "lifeOfTheBuilding": lifeOfTheBuilding,
                    "dateForRent": dateForRent,
                    "floorNumber": floorNumber,
                    "totalFloor": totalFloor,
                    "unitPerFloor": unitPerFloor,
                    "parking": parking,
                    "basement": basement,
                    "elevator": elevator,
                    "description": description,
                    "standardCapacity": standardCapacity,
                    "maxAddPeople": maxAddPeople,
                    "pricePerAddPeople": pricePerAddPeople,
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    set((state) => ({ loader: false }))

                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'آگهی یا موفقیت افزوده شد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'اشکال در ثبت آگهی لطفا دوباره تلاش کنید',
                        })
                    }

                    localStorage.setItem("detailFormId", res.data.id)
                }).catch(err => {
                    console.log(err);
                })
        },

        addPropertyApplicantRentBuy: async (

            id,
            adsPrptyTradeTypeCode,
            adsMasterCode,
            adsPrptyTypeCode,
            applicantType,
            buyPriceFrom,
            buyPriceTo,
            rentDepositFrom,
            rentDeposintTo,
            rentPriceFrom,
            rentPriceTo,
            metrageFrom,
            meterageTo,
            lifeOfBuildingFrom,
            lifeOfBulidingTo,
            description

        ) => {

            await axios.patch(`${baseURL}/Advertise/EditAdsPrptyApplicantRentBuy`,
                {
                    "id": id,
                    "adsMasterCode": adsMasterCode,
                    "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                    "adsPrptyTypeCode": adsPrptyTypeCode,
                    "applicantType": applicantType,
                    "buyPriceFrom": buyPriceFrom ? buyPriceFrom : 0,
                    "buyPriceTo": buyPriceTo ? buyPriceTo : 0,
                    "rentDepositFrom": rentDepositFrom ? rentDepositFrom : 0,
                    "rentDeposintTo": rentDeposintTo ? rentDeposintTo : 0,
                    "rentPriceFrom": rentPriceFrom ? rentPriceFrom : 0,
                    "rentPriceTo": rentPriceTo ? rentPriceTo : 0,
                    "metrageFrom": metrageFrom ? metrageFrom : 0,
                    "meterageTo": meterageTo ? meterageTo : 0,
                    "lifeOfBuildingFrom": lifeOfBuildingFrom ? lifeOfBuildingFrom : 0,
                    "lifeOfBulidingTo": lifeOfBulidingTo ? lifeOfBulidingTo : 0,
                    "description": description ? description : ""
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }

            )
                .then((res) => {

                    toast('عملیات افزودن آگهی موفقیت آمیز بود', {
                        position: "bottom-left",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }).catch(err => {
                    console.log(err);
                })
        },



        addsPrptyAuction: async (
            tblAdsPrptyDetailsCode,
            possibilityInPersonVisit,
            customerVisitDate,
            visitTimeFrom,
            visitTimeTo,
            address
        ) => {
            await axios.post(`${baseURL}/Advertise/EditAdsPrptyAuction`,
                {
                    "id": 0,
                    "tblAdsPrptyDetailsCode": tblAdsPrptyDetailsCode,
                    "possibilityInPersonVisit": possibilityInPersonVisit,
                    "customerVisitDate": customerVisitDate,
                    "visitTimeFrom": visitTimeFrom,
                    "visitTimeTo": visitTimeTo,
                    "address": address
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            )
                .then((res) => {
                    toast('عملیات افزودن آگهی موفقیت آمیز بود', {
                        position: "bottom-left",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }).catch(err => {
                    console.log(err);
                })
        },

        getAllAds: async () => {
            await axios.get(`${baseURL}/Advertise/GetMaster`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {

                    set((state) => ({ allAds: res.data }))

                })
        },

        editAdsMasterRegisterStatus: async (adsMasterId, registerStatusCode, RejectReasonCode, RejectDescription) => {
            axios
                .patch(
                    `${baseURL}/Advertise/EditAdsMasterRegisterStatus`,
                    {
                        "adsMasterId": adsMasterId,
                        "RegisterStatusCode": registerStatusCode,
                        "RejectReasonCode": RejectReasonCode,
                        "RejectDescription": RejectDescription
                    },
                    {
                        headers: {
                            accept: "text/plain",
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                        },
                    }
                )
                .then((res) => {
                    if (res.status == 200) {
                        // set((state) => ({ loader: false }))
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'وضعیت آگهی  با موفقیت تغییر کرد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                "تغییر وضعیت آگهی با خطا مواجه شد",
                        })
                    }
                })
                .then((err) => console.log("error patch data:", err));
        },

        getDetailMasterByQuery: async (page, lastId, adsMainCategoryCode, userCode, adsAdvertiseTypeCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, userTypeCode, countryCode,
            stateCode, cityCode, areaCode, priceFrom, priceTo, depositFrom, depositTo, rentFrom, rentTo,
            meterageFrom, meterageTo, buldingLifeFrom, buldingLifeTo, adsDateTimeFrom, adsDateTimeTo,
            parking, basement, elevator, searchQuery, isFilter, addedBy, registerStatusCode, rejectReasonCode, rejectDescription
        ) => {
            set((state) => ({ loaderForGetMoreAds: true }))
            set((state) => ({ allAds: [] }));
            // await axios.post(`${baseURL}/Advertise/GetDetailMasterByQuery`, {
            await axios.post(`${baseURL}/Advertise/GetDetailMasterByQueryWithPaginate`, {
                "page": page,
                "lastId": lastId,
                "adsMainCategoryCode": adsMainCategoryCode,
                "userCode": userCode,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "adsPrptyTypeCode": adsPrptyTypeCode,
                "userTypeCode": userTypeCode,
                "countryCode": countryCode,
                "stateCode": stateCode,
                "cityCode": cityCode,
                "areaCode": areaCode == [] ? [0] : areaCode,
                "priceFrom": priceFrom,
                "priceTo": priceTo,
                "depositFrom": depositFrom,
                "depositTo": depositTo,
                "rentFrom": rentFrom,
                "rentTo": rentTo,
                "meterageFrom": meterageFrom,
                "meterageTo": meterageTo,
                "buldingLifeFrom": buldingLifeFrom,
                "buldingLifeTo": buldingLifeTo,
                "adsDateTimeFrom": adsDateTimeFrom,
                "adsDateTimeTo": adsDateTimeTo,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "searchQuery": searchQuery,
                "addedBy": addedBy,
                "registerStatusCode": registerStatusCode ? registerStatusCode : 0,
                "rejectReasonCode": rejectReasonCode ? rejectReasonCode : 0,
                "rejectDescription": rejectDescription ? rejectDescription : "",
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {

                    set((state) => ({ loaderForGetMoreAds: false }))
                    // if (res.data.length) {
                    if (res.data.result.length) {
                        set((state) => ({ noAdFound: false }))
                        // const newIds = res.data.map((ad) => ad.id);
                        const newIds = res.data.result.map((ad) => ad.id);

                        set((state) => ({
                            // allAdsIDs: [...new Set([...state.allAdsIDs, ...newIds])] // Ensures no duplicate IDs
                            allAdsIDs: newIds
                        }));
                        // res?.data?.map((ad) => set((state) => ({ allAdsIDs: ad?.id }))
                        // )

                        if (searchQuery.length || isFilter) {
                            // set((state) => ({ allAds: res.data }))
                            set((state) => ({ allAds: res.data.result }))
                        } else {
                            // set((state) => ({ allAds: [...state.allAds, ...res.data] }));
                            set((state) => ({ allAds: [...state.allAds, ...res.data.result] }));
                        }
                    } else {
                        set((state) => ({ haseMore: false }))
                        set((state) => ({ noAdFound: true }))
                    }

                    
                    if (res.data.pagination) {
                        set((state) => ({ currentPage: res.data?.pagination.currentPage }))
                        set((state) => ({ itemsPerPage: res.data?.pagination.perPage }))
                        set((state) => ({ totalItems: res.data?.pagination.total }))
                    }




                })
        },


        getDetailsMasterByQuerywithPagination: async (page, lastId, adsMainCategoryCode, userCode, adsAdvertiseTypeCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, userTypeCode, countryCode,
            stateCode, cityCode, areaCode, priceFrom, priceTo, depositFrom, depositTo, rentFrom, rentTo,
            meterageFrom, meterageTo, buldingLifeFrom, buldingLifeTo, adsDateTimeFrom, adsDateTimeTo,
            parking, basement, elevator, searchQuery, isFilter, addedBy, registerStatusCode, rejectReasonCode, rejectDescription
        ) => {
            set((state) => ({ loaderForGetMoreAds: true }))
            await axios.post(`${baseURL}/Advertise/GetDetailMasterByQueryPaginate`, {
                "page": page,
                "lastId": lastId,
                "adsMainCategoryCode": adsMainCategoryCode,
                "userCode": userCode,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "adsPrptyTypeCode": adsPrptyTypeCode,
                "userTypeCode": userTypeCode,
                "countryCode": countryCode,
                "stateCode": stateCode,
                "cityCode": cityCode,
                "areaCode": areaCode == [] ? [0] : areaCode,
                "priceFrom": priceFrom,
                "priceTo": priceTo,
                "depositFrom": depositFrom,
                "depositTo": depositTo,
                "rentFrom": rentFrom,
                "rentTo": rentTo,
                "meterageFrom": meterageFrom,
                "meterageTo": meterageTo,
                "buldingLifeFrom": buldingLifeFrom,
                "buldingLifeTo": buldingLifeTo,
                "adsDateTimeFrom": adsDateTimeFrom,
                "adsDateTimeTo": adsDateTimeTo,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "searchQuery": searchQuery,
                "addedBy": addedBy,
                "registerStatusCode": registerStatusCode ? registerStatusCode : 0,
                "rejectReasonCode": rejectReasonCode ? rejectReasonCode : 0,
                "rejectDescription": rejectDescription ? rejectDescription : "",
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {

                    // set((state) => ({ loaderForGetMoreAds: false }))
                    // if (res.data.length) {
                    //     const newIds = res.data.map((ad) => ad.id);

                    //     console.log("newIds", newIds);
                    //     set((state) => ({
                    //         allAdsIDs: [...new Set([...state.allAdsIDs, ...newIds])] // Ensures no duplicate IDs
                    //     }));
                    //     // res?.data?.map((ad) => set((state) => ({ allAdsIDs: ad?.id }))
                    //     // )

                    //     if (searchQuery.length || isFilter) {
                    //         set((state) => ({ allAds: res.data }))
                    //     } else {
                    //         set((state) => ({ allAds: [...state.allAds, ...res.data] }));
                    //     }
                    // } else {
                    //     set((state) => ({ haseMore: false }))
                    // }
                    if (res.data) {
                        set((state) => ({ currentPage: res.data?.currentPage }))
                        set((state) => ({ itemsPerPage: res.data?.perPage }))
                        set((state) => ({ totalItems: res.data?.total }))
                    }
                    console.log(res?.data, "ressssssss in getDetailsMasterByQuerywithPagination");



                })
        },
        deleteAdsMaster: async (masterId, userId) => {
            set((state) => ({ loader: true }))
            await axios.delete(`${baseURL}/Advertise/DeleteAdsMaster?MasterId=${masterId}&UserId=${userId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            })
                .then((res) => {
                    console.log("ertyf", res.status == 200);

                    if (res.status == 200) {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'آگهی با موفقیت حذف شد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'اشکال در حذف آگهی لطفا دوباره تلاش کنید',
                        })
                    }
                })
        },
        getRejectionnReasons: async (baseInfoType) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseURL}/BaseInfo/GetBaseInfoByType?baseInfoType=${baseInfoType}`)
                .then((res) => {
                    if (res.data) {


                        set((state) => ({ adsRejectReason: res.data }))
                        set((state) => ({ loader: false }))
                    }
                }, {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterByPhoneNumber: async (
            phoneNumber
        ) => {
            set((state) => ({ loaderForGetMoreAds: true }))
            await axios.post(`${baseURL}/AdvertisePhoneNumber/GetAdsMasterByPhoneNumber`, {
                phoneNumber: phoneNumber
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {


                    if (res.data) {
                        // set((state) => ({ adsTitleByPhoneNumber: res.data?.adsTitle }))
                        // set((state) => ({ adsMasterIDByPhoneNumber: res.data?.id }))
                        // set((state) => ({ adsPrptyTypeCodeByPhoneNumber: res.data?.total }))
                        // set((state) => ({ adsPrptyTradeTypeCode: res.data?.total }))
                        set((state) => ({ responseFromAdsMasterByPhoneNumber: res.data }))
                    }




                })
        },


    }
}))

// export const todosGet = useGetTodos.setState